import { EChartsOption } from "echarts";

import { ChartDecorator } from "./decorator";

export const scatterTooltipDecorator: ChartDecorator = {
  decorate: function (option: EChartsOption): EChartsOption {
    if (!option.tooltip) {
      option.tooltip = {};
    }
    Object.assign(option.tooltip, {
      trigger: "item",
      confine: true,
      enterable: false,
      showDelay: 500,
      hideDelay: 0,
      show: true,
      axisPointer: {
        label: {
          precision: 2,
          show: true
        },
        type: "cross"
      }
    });
    return option;
  }
};

export const spearmanCorrelationTooltipDecorator: ChartDecorator = {
  decorate: function (option: EChartsOption): EChartsOption {
    if (!option.tooltip) {
      option.tooltip = {};
    }
    Object.assign(option.tooltip, {
      trigger: "axis",
      showContent: false,
      confine: true,
      enterable: false,
      showDelay: 500,
      hideDelay: 0,
      show: true,
      axisPointer: {
        label: {
          precision: 2,
          show: true
        },
        type: "cross"
      }
    });
    return option;
  }
};
